module.exports = __webpack_public_path__ + "assets/codeable-team-header-blurred.5b90a866.png";